import PropTypes from "prop-types";
import React from "react";
import DataDefinitionModule
    from "lib/dataentry/lib/datadefinition/DataDefinitionModule";
import ActiveFormStore, { FIRST_FIELD } from "data/ActiveFormStore";
import DataDefStore from "data/meta/DataDefStore";
import useFluxStore from "@armus/use-flux-store";

const DataDefinitionsContainer = props => {
    const ctx = props.fluxContext;
    const state = useFluxStore(() => {
        const ctrl = ActiveFormStore.getActiveControl(ctx);
        const next = {};
        if (ctrl == null) return next;
        if (ctrl.fieldKey !== FIRST_FIELD) {
            const lo = DataDefStore.getDefinitionsLO(
                ctrl.entityKey,
                ctrl.fieldKey,
            );
            if (lo.hasValue()) {
                Object.assign(next, lo.getRequiredValue());
            }
        }
        next.shortName = ctrl.fieldKey;
        next.keyboardShortcuts = ctrl.keyboardShortcuts;
        return next;
    }, [
        ActiveFormStore,
        DataDefStore,
    ], [ctx]);
    return <DataDefinitionModule {...state} />;
};

DataDefinitionsContainer.propTypes = {
    fluxContext: PropTypes.string.isRequired,
};

export default DataDefinitionsContainer;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/datadefinition/DataDefinitionsContainer.js